import { render, staticRenderFns } from "./dapp.vue?vue&type=template&id=e2e593da&scoped=true"
import script from "./dapp.vue?vue&type=script&lang=js"
export * from "./dapp.vue?vue&type=script&lang=js"
import style0 from "./dapp.vue?vue&type=style&index=0&id=e2e593da&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e593da",
  null
  
)

export default component.exports